import React, { useCallback, useMemo, useState } from 'react';
import classNames from 'classnames';
import {
  BossModeAccoutnsTable,
  COLUMN_SIZE,
  HEADING_TRANSLATIONS,
  SORTING_VALUES,
  TABLE_COLUMNS,
} from './components/data';
import ReorderResizeTable from 'components/ReorderResizeTable';
import { User } from 'models/User';
import { BODY_CONTENT_GENERATE } from './components';
import useCallbackRef from 'hooks/useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import RemoveBossModeModal from '../RemoveBossModeModal';
import {
  ColumnFilterOption,
  ColumnSizing,
} from 'components/ReorderResizeTable/types';

import './BossModeTable.styles.scss';

type BossModeTableProps = {
  className?: string;
  bossModeAccounts: User[];
  isLoading: boolean;
  totalPages: number;
  totalItems: number;
  columns: typeof TABLE_COLUMNS;
  columnSizing: ColumnSizing;
  columnFilterOptions?: Partial<
    Record<keyof BossModeAccoutnsTable, ColumnFilterOption>
  >;
  refetch: () => void;
  onReorder: (columns: typeof TABLE_COLUMNS) => void;
  onColumnSizingChange: (columnSizing: ColumnSizing) => void;
};

const BossModeTable: React.FC<BossModeTableProps> = (props) => {
  const {
    className,
    bossModeAccounts,
    isLoading,
    totalPages,
    totalItems,
    columnFilterOptions,
    columns,
    columnSizing,
    refetch,
    onReorder,
    onColumnSizingChange,
  } = props;

  const [selectedBossMode, setSelectedBossMode] = useState<User>();

  const [modal, modalRef] = useCallbackRef<ModalRef>(null);

  const classes = classNames('boss-mode-table', className);

  const onRemoveBossMode = useCallback(
    (bossMode: User) => {
      setSelectedBossMode(bossMode);
      modal?.open();
    },
    [modal],
  );

  const renderedContent = useMemo(
    () =>
      TABLE_COLUMNS.reduce(
        (acc, col) => ({
          ...acc,
          [col]: (bossMode: User) =>
            BODY_CONTENT_GENERATE[col]({
              bossMode,
              onRemoveBossMode,
            }),
        }),
        {},
      ),
    [onRemoveBossMode],
  );

  return (
    <>
      <ReorderResizeTable
        className={classes}
        columns={columns}
        customSizes={COLUMN_SIZE}
        sortingValues={SORTING_VALUES}
        columnFilterOptions={columnFilterOptions}
        data={bossModeAccounts as any as BossModeAccoutnsTable[]}
        isDataLoading={isLoading}
        totalPages={totalPages}
        totalItems={totalItems}
        recordName="account"
        headingTranslations={HEADING_TRANSLATIONS}
        tableContentTransformations={renderedContent}
        columnSizing={columnSizing}
        onColumnSizingChange={onColumnSizingChange}
        onReorder={onReorder}
      />

      <RemoveBossModeModal
        ref={modalRef}
        bossMode={selectedBossMode}
        onRemoveBossMode={refetch}
      />
    </>
  );
};

export default BossModeTable;
